import { useState } from 'react';
import { Search, X, SlidersHorizontal } from 'lucide-react';
import {
  MODULLER, ZAMAN_ARALIK, MUSTERILER
} from '../constants/filters';

export default function FilterBar({
  filtreler, onChange, musteriSecimGoster = true
}) {
  const [ozelAralik, setOzelAralik] = useState(false);

  const set = (key, val) => onChange({ ...filtreler, [key]: val });

  const aktifFiltreSayisi = [
    filtreler.musteri, filtreler.modul, filtreler.arama
  ].filter(Boolean).length;

  function sifirla() {
    onChange({
      ...filtreler,
      musteri: '', modul: '', arama: '', sure: 24, baslangic: '', bitis: '',
    });
    setOzelAralik(false);
  }

  const selectCls = 'border border-gray-200 rounded-lg px-3 py-1.5 text-sm bg-white ' +
    'focus:ring-2 focus:ring-blue-400 focus:outline-none focus:border-blue-400 ' +
    'text-slate-600 cursor-pointer transition-colors hover:border-gray-300';

  return (
    <div className='bg-white border border-gray-200 rounded-xl p-4 mb-5
                    shadow-sm space-y-3'>

      {/* Satır 1: Müşteri + Zaman */}
      <div className='flex flex-wrap gap-2 items-center'>

        {/* Müşteri */}
        {musteriSecimGoster && (
          <select value={filtreler.musteri}
            onChange={e => set('musteri', e.target.value)}
            className={`${selectCls} min-w-[180px]`}>
            <option value='' disabled>👥 Müşteri Seçin</option>
            {MUSTERILER.map(m => (
              <option key={m.value} value={m.value}>{m.label}</option>
            ))}
          </select>
        )}

        {/* Zaman */}
        <select value={ozelAralik ? 'custom' : filtreler.sure}
          onChange={e => {
            const val = e.target.value;
            if (val === 'custom') { setOzelAralik(true); return; }
            setOzelAralik(false);
            // bugun/dun string, diğerleri sayı
            const parsed = Number(val);
            set('sure', isNaN(parsed) ? val : parsed);
          }}
          className={selectCls}>
          {ZAMAN_ARALIK.map(z => (
            <option key={z.value} value={z.value}>🕐 {z.label}</option>
          ))}
        </select>

        {/* Özel tarih */}
        {ozelAralik && (
          <div className='flex items-center gap-2 bg-blue-50 px-3 py-1.5
                          rounded-lg border border-blue-200'>
            <input type='datetime-local' value={filtreler.baslangic}
              onChange={e => set('baslangic', e.target.value)}
              className='text-xs border-0 bg-transparent focus:outline-none
                         text-slate-600' />
            <span className='text-slate-400'>—</span>
            <input type='datetime-local' value={filtreler.bitis}
              onChange={e => set('bitis', e.target.value)}
              className='text-xs border-0 bg-transparent focus:outline-none
                         text-slate-600' />
          </div>
        )}
      </div>

      {/* Satır 2: Dinamik filtreler */}
      <div className='flex flex-wrap gap-2 items-center'>

        <div className='flex items-center gap-1.5 text-xs text-slate-400'>
          <SlidersHorizontal size={12} />
          <span>Filtreler:</span>
        </div>

        {/* Modül */}
        <select value={filtreler.modul}
          onChange={e => set('modul', e.target.value)}
          className={selectCls}>
          {MODULLER.map(m => (
            <option key={m.value} value={m.value}>{m.label}</option>
          ))}
        </select>

        {/* Sıralama */}
        <select value={filtreler.sirala}
          onChange={e => set('sirala', e.target.value)}
          className={selectCls}>
          <option value='zaman_desc'>En Yeni ↓</option>
          <option value='zaman_asc'>En Eski ↑</option>
        </select>

        {/* Arama */}
        <div className='relative flex-1 min-w-[220px]'>
          <Search size={13} className='absolute left-3 top-2.5 text-gray-400' />
          <input
            placeholder='Hata mesajı, endpoint, payload...'
            value={filtreler.arama}
            onChange={e => set('arama', e.target.value)}
            className='w-full pl-8 pr-3 py-1.5 border border-gray-200 rounded-lg
                       text-sm focus:ring-2 focus:ring-blue-400 focus:outline-none
                       focus:border-blue-400 placeholder-gray-400 transition-colors'
          />
        </div>

        {/* Temizle */}
        {aktifFiltreSayisi > 0 && (
          <button onClick={sifirla}
            className='flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium
                       text-red-500 border border-red-200 rounded-lg
                       hover:bg-red-50 transition-colors'>
            <X size={11} />
            {aktifFiltreSayisi} filtre temizle
          </button>
        )}
      </div>
    </div>
  );
}
